import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { ShowLessIcon, ShowMoreIcon } from '../../../SvgUtility'
import { CommonColorCodes } from '../../../utility/CommonColorCodes'
import FilterWithSearch from './FilterWithSearch'
import { FilterHeader, FilterNameBold, FilterName } from '../../../css/Style'
import { APPLICATION, CATEGORY, USECASE } from '../../../constants/Constants'

interface FiltersPaneProps {
  useCases: string[],
  categories: string[],
  applications: string[],
  filterOnClickAction: (useCase?: string, categories?: string, applications?: string) => void;
  useCaseFilter?: string | null;
  categoriesFilter?: string | null;
  applicationsFilter?: string | null;
  toggleMenu?: boolean | null;
  enableShowLess:(arg0: boolean) => void;
  showLessEnabled: boolean;
}

interface HiddenProps {
  hide: boolean;
}

const FilterContainer = styled.div<HiddenProps>`
align-items: self-start;
text-align: left;
width: 265px;
flex: none;
@media (min-width: 0px) and (max-width: 900px) {
  display: ${(props) => props.hide ? 'inline-block' : 'none'};
  width : 100%;
  overflow-y : scroll;
  height : calc(100vh)
}
@media (min-width: 901px) and (max-width: 1349px) {
  width : 25%;
  overflow-y : scroll;
}
`

const UseCasesContainer = styled.div`
margin-left: 12px;

`

const ShowLess = styled.div`
margin-top: 20px;
color: #35324A;
display: 'flex';
cursor: pointer;
`

const ShowLessMoreText = styled.div`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
display: inline;
margin-left: 13px;
color: #EA5834;
`

const ShowLessIconContainer = styled.span`
margin-top: -2px;
`

const HorizontalLine = styled.div`
background: ${CommonColorCodes.GREY_2};
height: 1px;
margin-top: 40px;
width: 235px;
`
const MAX_FILTERS = 5

const FiltersPane: React.FunctionComponent<FiltersPaneProps> = ({
  useCases,
  categories,
  applications,
  filterOnClickAction,
  useCaseFilter,
  categoriesFilter,
  applicationsFilter,
  enableShowLess,
  showLessEnabled,
  toggleMenu
}) => {
  const [useCasesSlicedArr, setUseCasesSlicedArr] = useState(useCases.slice(0, MAX_FILTERS))

  useEffect(() => {
    showLessEnabled ? setUseCasesSlicedArr(useCases) : setUseCasesSlicedArr(useCases.slice(0, MAX_FILTERS))
  }, [showLessEnabled])

  const showNav = (): boolean => {
    return toggleMenu || false
  }

  return (
    <FilterContainer hide ={showNav()}>
      <UseCasesContainer>
        <FilterHeader> { USECASE } </FilterHeader>
        {
          useCasesSlicedArr.map((useCase) => {
            return useCase === useCaseFilter
              ? <FilterNameBold key={useCase}>{useCase}</FilterNameBold>
              : <FilterName key={useCase} onClick={() => filterOnClickAction(useCase)}>
                {useCase}</FilterName>
          })
        }
        <ShowLess>
          <ShowLessIconContainer>
          </ShowLessIconContainer>
          { showLessEnabled
            ? <span onClick={() => enableShowLess(false)}><ShowLessIcon width='14px' height='6px' fill='#EA5834' />
            <ShowLessMoreText>Show Less</ShowLessMoreText></span>
            : <span onClick={() => enableShowLess(true)}><ShowMoreIcon width='14px' height='6px' fill='#EA5834' />
            <ShowLessMoreText >Show More</ShowLessMoreText></span>
          }
        </ShowLess>
      </UseCasesContainer>
      <HorizontalLine></HorizontalLine>
      <FilterWithSearch title= {CATEGORY} filterNameArr={categories} filterOnClickAction={filterOnClickAction} appliedFilterName={categoriesFilter} />
      <HorizontalLine></HorizontalLine>
      <FilterWithSearch title={APPLICATION} filterNameArr={applications} filterOnClickAction={filterOnClickAction} appliedFilterName={applicationsFilter} />
      <HorizontalLine></HorizontalLine>
    </FilterContainer>
  )
}

export default FiltersPane
